import React from 'react';
import { useBlockingRouter } from '../../../hooks/useBlockingRouter';

import SideNavLinkItem from './SideNavLinkItem/SideNavLinkItem';
import SideNavDropdownItem from './SideNavDropdownItem/SideNavDropdownItem';
import styles from './SideNav.module.scss';
import { ListConfigType } from './SideNavContainer';
import { Box } from '@mui/material';
import { isSideNavRouteActive } from './helpers';

export default function SideNavComponent( {
	listConfig,
}: {
	listConfig: ListConfigType;
} ) {
	const router = useBlockingRouter();
	const currentPath = router.asPath;

	return (
		<Box className={ styles.root } data-cy={ 'sideNav' }>
			{ listConfig
				.filter(
					( listItem ) =>
						listItem.isVisible !== false &&
						listItem.isDisabled !== true &&
						( 'items' in listItem ||
							( 'href' in listItem && listItem.href ) ||
							( 'onClick' in listItem && listItem.onClick ) )
				)
				.map( ( listItem ) => {
					if ( 'items' in listItem ) {
						return (
							<SideNavDropdownItem listItem={ listItem } key={ listItem.id } />
						);
					} else if (
						( 'href' in listItem && listItem.href ) ||
						( 'onClick' in listItem && listItem.onClick )
					) {
						return (
							<SideNavLinkItem
								key={ listItem.id }
								listItem={ {
									isActive:
										'href' in listItem &&
										isSideNavRouteActive( currentPath, listItem.href ),
									...listItem,
								} }
							/>
						);
					}
				} ) }
		</Box>
	);
}
